const statusAskCheckout = {
  PENDING: 1,
  PAID: 2,
  REJECT: 3,
};
 
const getStatusAskCheckoutString = () => {
  let data = {};
  data[statusAskCheckout.PENDING] = "در حال بررسی درخواست";
  data[statusAskCheckout.PAID] = "پرداخت شده";
  data[statusAskCheckout.REJECT] = "رد شده"
 
  return data;
};


export default {
  statusAskCheckout,
  getStatusAskCheckoutString,
};
